import {getPromotionTypeName, PromotionType} from "../helpers/PromotionType";
import {IAmplitudeOfferPromotionTrackingParamsWithItemId} from "./get_amplitude_offer_promotion_event_properties";

interface IGetAmplitudePromotionModalTrackingContextParams {
    promotion?: {
        id: number;
        name: string;
        description: string | null;
        type: number;
    } | null;
    fallbackTitle?: string;
    offerId: number;
    propertyId: number | null;
    itemListId?: string;
}

export const getAmplitudePromotionModalTrackingContext = (
    params: IGetAmplitudePromotionModalTrackingContextParams
): IAmplitudeOfferPromotionTrackingParamsWithItemId => {
    const promotionType =
        params.promotion?.type !== undefined && params.promotion?.type !== null ? (params.promotion.type as PromotionType) : PromotionType.PROMOTION;
    const headline = params.promotion?.name?.trim() || params.fallbackTitle?.trim() || getPromotionTypeName(promotionType);
    const description = params.promotion?.description?.trim() || null;

    return {
        creativeName: headline,
        creativeSlot: "modal",
        promotionId: params.promotion?.id,
        promotionName: params.promotion?.name?.trim() || headline,
        promotionContent: description,
        location: params.propertyId ? "property_page" : "investment_page",
        itemListId: params.itemListId,
        itemId: params.offerId,
        propertyId: params.propertyId ?? undefined
    };
};
import {getPromotionTypeName, PromotionType} from "../helpers/PromotionType";
import {IAmplitudeOfferPromotionTrackingParamsWithItemId} from "./get_amplitude_offer_promotion_event_properties";

interface IGetAmplitudePromotionModalTrackingContextParams {
    promotion?: {
        id: number;
        name: string;
        description: string | null;
        type: number;
    } | null;
    fallbackTitle?: string;
    offerId: number;
    propertyId: number | null;
    itemListId?: string;
}

export const getAmplitudePromotionModalTrackingContext = (
    params: IGetAmplitudePromotionModalTrackingContextParams
): IAmplitudeOfferPromotionTrackingParamsWithItemId => {
    const promotionType =
        params.promotion?.type !== undefined && params.promotion?.type !== null ? (params.promotion.type as PromotionType) : PromotionType.PROMOTION;
    const headline = params.promotion?.name?.trim() || params.fallbackTitle?.trim() || getPromotionTypeName(promotionType);
    const description = params.promotion?.description?.trim() || null;

    return {
        creativeName: headline,
        creativeSlot: "modal",
        promotionId: params.promotion?.id,
        promotionName: params.promotion?.name?.trim() || headline,
        promotionContent: description,
        location: params.propertyId ? "property_page" : "investment_page",
        itemListId: params.itemListId,
        itemId: params.offerId,
        propertyId: params.propertyId ?? undefined
    };
};
